import {cn} from '@mgp-fe/shared/utils';
import React from 'react';

export default function Skeleton({
	className,
	...props
}: React.HTMLAttributes<HTMLDivElement>) {
	return <div className={cn('animate-pulse-slow rounded-md bg-muted/10', className)} {...props}/>;
}
